import React from "react";
import { EverpassImage } from "./SalesLogos";
import { getModel } from "../../utils/models";

const SupportInfo = () => {
    const model = getModel();

    switch (model) {
        case "xumo":
            return (
                <>
                    <div className="contact-info-text">
                        <div>If you need support to activate your device</div>
                        <div>
                            please direct to <span className="span-semi-bold">{process.env.REACT_APP_XUMO_INFO_SHORTEN_LINK}</span>
                        </div>
                        <div>
                            or call <span className="span-semi-bold">{process.env.REACT_APP_SPECTRUM_HELP_DESK_NUMBER}</span>
                        </div>
                    </div>
                </>
            );
        case "xi6":
        case "xid":
        case "xg2v2":
            return (
                <div className="contact-info-text">
                    <div>If you need support to activate your subscription</div>
                    <div>
                        direct to <span className="span-semi-bold">{process.env.REACT_APP_COMCAST_INFO_SHORTEN_LINK}</span>
                    </div>
                    <div>
                        or contact EverPass at <span className="span-semi-bold">{process.env.REACT_APP_COMCAST_HELP_DESK_NUMBER}</span>
                    </div>
                </div>
            );
        default:
            return (
                <>
                    <div className="contact-info-text">
                        <div>If you need support to activate your device</div>
                        <div>
                            please reach out to <b>support@everpass.com</b>
                        </div>
                        <div>
                            or call <b>855-787-7469</b>
                        </div>
                    </div>
                    <EverpassImage />
                </>
            );
    }
};

export default SupportInfo;